/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeRegistrationShift } from '../../models/employee-registration-shift';

export interface GetShiftsForFilter$Params {
  workCenterId: number;
}

export function getShiftsForFilter(http: HttpClient, rootUrl: string, params: GetShiftsForFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeRegistrationShift>>> {
  const rb = new RequestBuilder(rootUrl, getShiftsForFilter.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeRegistrationShift>>;
    })
  );
}

getShiftsForFilter.PATH = '/api/v1/{workCenterId}/GetShiftsForFilter';
